/**
 * Sets the environment data attribute on the HTML element
 * This allows CSS to apply environment-specific styles
 */
export function setEnvironmentClass() {
  const env = import.meta.env.MODE || "development";
  document.documentElement.setAttribute("data-env", env);
}

// Call immediately when this module is imported
setEnvironmentClass();
